import { render, staticRenderFns } from "./ServiceRequestDetailModal.vue?vue&type=template&id=1132b5f9&scoped=true"
import script from "./ServiceRequestDetailModal.vue?vue&type=script&lang=js"
export * from "./ServiceRequestDetailModal.vue?vue&type=script&lang=js"
import style0 from "./ServiceRequestDetailModal.vue?vue&type=style&index=0&id=1132b5f9&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1132b5f9",
  null
  
)

export default component.exports